import { logEvent } from "@/service/logs/log";
import { clientGet } from "@/service/client-api/client-api";

export async function logPermissionEvent(
  type:
    | "become_medic"
    | "doctor_choose_specialization"
    | "doctor_choose_status"
    | "save_to_newsletter",
  logView: LogView,
  oldSnapshot: any,
) {
  const newSnapshot = (await clientGet("profile.info")) as any;
  logEvent("user_permission_block_updated", logView, {
    block_type: type,
    new_state: newSnapshot,
    old_state: oldSnapshot,
  });
}
